namespace $ {

	export type $mol_report_handler_type = (event: Event | string, url?: string, line?: number, col?: number, error?: Error) => void

	export const $mol_report_handler_all = new Set<$mol_report_handler_type>()

	function handler(event: Event | string, url?: string, line?: number, col?: number, error?: Error) {
		for (const handler of $mol_report_handler_all) {
			try {
				handler(event, url, line, col, error)
			} catch (e) {}
		}
	}
	const handler_promise = (event: PromiseRejectionEvent) => handler('Unhandled Rejection', '', 0, 0, event.reason )
	const handler_promise_node = (reason: Error) => handler('Unhandled Rejection', '', 0, 0, reason )

	if( 'addEventListener' in globalThis ) {
		globalThis.addEventListener('error', handler)
		globalThis.addEventListener('unhandledrejection', handler_promise)
	}
	
	if( 'process' in globalThis ) {
		process.on('uncaughtExceptionMonitor', handler)
    	process.on('unhandledRejection', handler_promise_node)
	}

	const console_error = console.error


	console.error = function console_error_custom( ... args ) {

		const format = (val: unknown) => typeof val === 'string'
			? val.replace(/[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nqry=><]/g, '')
			: JSON.stringify(val)

		const secondary = args.slice(1)
		const first = typeof args[0] === 'string'
			? args[0].replaceAll( /%(?:\.\d+)?[disfcoO]/g, spec => spec === '%c' ? (secondary.shift(), '') : secondary.shift() )
			: args[0]

		secondary.unshift(first)
		const result = secondary.map(format).join(' ')

		handler( result )
		console_error.apply( console, args )
	}

}
